module.exports = __webpack_public_path__ + "img/full-map.305e7070.svg";